<div class="container">
  <br />
  <h3 class="providerWebsite-title-header">
    {{ providerWebsiteName }} - {{ 'label.' + resourceTitle | translate }}
  </h3>
  <div class="row">
    <h4 class="resource-type-header">{{ 'label.Title' | translate }}</h4>
    <div class="col-sm-6">
      <div class="form-group">
        <label for="primary">{{ language?.primaryLanguageName }}:</label>
        <input
          type="text"
          class="form-control"
          id="primary"
          [ngModel]="data && data.primaryData && data.primaryData.titleResource"
          (ngModelChange)="
            data &&
              data.primaryData &&
              (data.primaryData.titleResource = $event)
          "
        />
      </div>
      <div class="form-group">
        <label for="alternative"
          >{{ language?.alternativeLanguageName }}:</label
        >
        <input
          type="text"
          class="form-control"
          id="alternative"
          [ngModel]="
            data && data.alternativeData && data.alternativeData.titleResource
          "
          (ngModelChange)="
            data &&
              data.alternativeData &&
              (data.alternativeData.titleResource = $event)
          "
        />
      </div>
    </div>
  </div>

  <div class="row">
    <h4 class="resource-type-header">{{ 'label.Content' | translate }}</h4>
    <div class="col-sm-12">
      <div class="form-group">
        <label for="primaryContent">{{ language?.primaryLanguageName }}:</label>
        <ckeditor
          id="primaryContent"
          [ngModel]="
            data && data.primaryData && data.primaryData.contentResource
          "
          (ngModelChange)="
            data &&
              data.primaryData &&
              (data.primaryData.contentResource = $event)
          "
        ></ckeditor>
      </div>
      <div class="form-group">
        <label for="alternativeContent"
          >{{ language?.alternativeLanguageName }}:</label
        >
        <ckeditor
          id="alternativeContent"
          [ngModel]="
            data && data.alternativeData && data.alternativeData.contentResource
          "
          (ngModelChange)="
            data &&
              data.alternativeData &&
              (data.alternativeData.contentResource = $event)
          "
        ></ckeditor>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-5"></div>
    <div class="col-sm-5"></div>
    <div class="col-sm-2">
      <button class="btn btn-success btn-custom" (click)="onUpdate()">
        Update
      </button>
      <button class="btn btn-danger btn-custom" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
